/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CallDto } from '../model/callDto';
import { CallTypeResponse } from '../model/callTypeResponse';
import { ClickToCallResponse } from '../model/clickToCallResponse';
import { GetActiveCallsResponse } from '../model/getActiveCallsResponse';
import { GetEndUserCallLogResponse } from '../model/getEndUserCallLogResponse';
import { Response } from '../model/response';
import { TransferCallResponse } from '../model/transferCallResponse';
import { TransferDto } from '../model/transferDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { CallControlServiceInterface }                            from './callControl.serviceInterface';


@Injectable()
export class CallControlService implements CallControlServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param caller 
     * @param callee 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clickToCall2(organization?: string, login?: string, caller?: string, callee?: string, observe?: 'body', reportProgress?: boolean): Observable<ClickToCallResponse>;
    public clickToCall2(organization?: string, login?: string, caller?: string, callee?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClickToCallResponse>>;
    public clickToCall2(organization?: string, login?: string, caller?: string, callee?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClickToCallResponse>>;
    public clickToCall2(organization?: string, login?: string, caller?: string, callee?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (caller !== undefined && caller !== null) {
            queryParameters = queryParameters.set('caller', <any>caller);
        }
        if (callee !== undefined && callee !== null) {
            queryParameters = queryParameters.set('callee', <any>callee);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<ClickToCallResponse>(`${this.basePath}/calls/clickToCall`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param mainNumber 
     * @param queueId 
     * @param agent 
     * @param callee 
     * @param displayNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clickToCallExtended1(organization?: string, login?: string, mainNumber?: string, queueId?: string, agent?: string, callee?: string, displayNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<ClickToCallResponse>;
    public clickToCallExtended1(organization?: string, login?: string, mainNumber?: string, queueId?: string, agent?: string, callee?: string, displayNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClickToCallResponse>>;
    public clickToCallExtended1(organization?: string, login?: string, mainNumber?: string, queueId?: string, agent?: string, callee?: string, displayNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClickToCallResponse>>;
    public clickToCallExtended1(organization?: string, login?: string, mainNumber?: string, queueId?: string, agent?: string, callee?: string, displayNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (mainNumber !== undefined && mainNumber !== null) {
            queryParameters = queryParameters.set('mainNumber', <any>mainNumber);
        }
        if (queueId !== undefined && queueId !== null) {
            queryParameters = queryParameters.set('queueId', <any>queueId);
        }
        if (agent !== undefined && agent !== null) {
            queryParameters = queryParameters.set('agent', <any>agent);
        }
        if (callee !== undefined && callee !== null) {
            queryParameters = queryParameters.set('callee', <any>callee);
        }
        if (displayNumber !== undefined && displayNumber !== null) {
            queryParameters = queryParameters.set('displayNumber', <any>displayNumber);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<ClickToCallResponse>(`${this.basePath}/calls/call`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param caller 
     * @param callee 
     * @param displayNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clickToCallWithDisplayNumber1(organization?: string, login?: string, caller?: string, callee?: string, displayNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<ClickToCallResponse>;
    public clickToCallWithDisplayNumber1(organization?: string, login?: string, caller?: string, callee?: string, displayNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClickToCallResponse>>;
    public clickToCallWithDisplayNumber1(organization?: string, login?: string, caller?: string, callee?: string, displayNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClickToCallResponse>>;
    public clickToCallWithDisplayNumber1(organization?: string, login?: string, caller?: string, callee?: string, displayNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (caller !== undefined && caller !== null) {
            queryParameters = queryParameters.set('caller', <any>caller);
        }
        if (callee !== undefined && callee !== null) {
            queryParameters = queryParameters.set('callee', <any>callee);
        }
        if (displayNumber !== undefined && displayNumber !== null) {
            queryParameters = queryParameters.set('displayNumber', <any>displayNumber);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<ClickToCallResponse>(`${this.basePath}/calls/call`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public clickToCallWithDto1(organization?: string, login?: string, body?: CallDto, observe?: 'body', reportProgress?: boolean): Observable<ClickToCallResponse>;
    public clickToCallWithDto1(organization?: string, login?: string, body?: CallDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClickToCallResponse>>;
    public clickToCallWithDto1(organization?: string, login?: string, body?: CallDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClickToCallResponse>>;
    public clickToCallWithDto1(organization?: string, login?: string, body?: CallDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ClickToCallResponse>(`${this.basePath}/calls/callWithDto`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public connectAtoC1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public connectAtoC1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public connectAtoC1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public connectAtoC1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/calls/connectAtoC`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public connectCalls1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public connectCalls1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public connectCalls1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public connectCalls1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/calls/connectCalls`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sessionId 
     * @param intendedLeg 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public disconnectCall2(sessionId: number, intendedLeg: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public disconnectCall2(sessionId: number, intendedLeg: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public disconnectCall2(sessionId: number, intendedLeg: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public disconnectCall2(sessionId: number, intendedLeg: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling disconnectCall2.');
        }

        if (intendedLeg === null || intendedLeg === undefined) {
            throw new Error('Required parameter intendedLeg was null or undefined when calling disconnectCall2.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/calls/disconnect/${encodeURIComponent(String(sessionId))}/${encodeURIComponent(String(intendedLeg))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getActiveCalls2(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetActiveCallsResponse>;
    public getActiveCalls2(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetActiveCallsResponse>>;
    public getActiveCalls2(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetActiveCallsResponse>>;
    public getActiveCalls2(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetActiveCallsResponse>(`${this.basePath}/calls/activecalls`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param caller 
     * @param callee 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCallType1(organization?: string, login?: string, caller?: string, callee?: string, observe?: 'body', reportProgress?: boolean): Observable<CallTypeResponse>;
    public getCallType1(organization?: string, login?: string, caller?: string, callee?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CallTypeResponse>>;
    public getCallType1(organization?: string, login?: string, caller?: string, callee?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CallTypeResponse>>;
    public getCallType1(organization?: string, login?: string, caller?: string, callee?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (caller !== undefined && caller !== null) {
            queryParameters = queryParameters.set('caller', <any>caller);
        }
        if (callee !== undefined && callee !== null) {
            queryParameters = queryParameters.set('callee', <any>callee);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<CallTypeResponse>(`${this.basePath}/calls/type`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param from 
     * @param to 
     * @param entriesPerPage 
     * @param page 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEndUserCallLog1(organization?: string, login?: string, from?: string, to?: string, entriesPerPage?: number, page?: number, observe?: 'body', reportProgress?: boolean): Observable<GetEndUserCallLogResponse>;
    public getEndUserCallLog1(organization?: string, login?: string, from?: string, to?: string, entriesPerPage?: number, page?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetEndUserCallLogResponse>>;
    public getEndUserCallLog1(organization?: string, login?: string, from?: string, to?: string, entriesPerPage?: number, page?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetEndUserCallLogResponse>>;
    public getEndUserCallLog1(organization?: string, login?: string, from?: string, to?: string, entriesPerPage?: number, page?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from);
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to);
        }
        if (entriesPerPage !== undefined && entriesPerPage !== null) {
            queryParameters = queryParameters.set('entriesPerPage', <any>entriesPerPage);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetEndUserCallLogResponse>(`${this.basePath}/calls/callLog`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param sessionId 
     * @param intendedLeg 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public toggleCall2(sessionId: number, intendedLeg: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public toggleCall2(sessionId: number, intendedLeg: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public toggleCall2(sessionId: number, intendedLeg: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public toggleCall2(sessionId: number, intendedLeg: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling toggleCall2.');
        }

        if (intendedLeg === null || intendedLeg === undefined) {
            throw new Error('Required parameter intendedLeg was null or undefined when calling toggleCall2.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/calls/toggle/${encodeURIComponent(String(sessionId))}/${encodeURIComponent(String(intendedLeg))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param caller 
     * @param callee 
     * @param transferee 
     * @param transferMode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transferCall2(organization?: string, login?: string, caller?: string, callee?: string, transferee?: string, transferMode?: number, observe?: 'body', reportProgress?: boolean): Observable<TransferCallResponse>;
    public transferCall2(organization?: string, login?: string, caller?: string, callee?: string, transferee?: string, transferMode?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransferCallResponse>>;
    public transferCall2(organization?: string, login?: string, caller?: string, callee?: string, transferee?: string, transferMode?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransferCallResponse>>;
    public transferCall2(organization?: string, login?: string, caller?: string, callee?: string, transferee?: string, transferMode?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (caller !== undefined && caller !== null) {
            queryParameters = queryParameters.set('caller', <any>caller);
        }
        if (callee !== undefined && callee !== null) {
            queryParameters = queryParameters.set('callee', <any>callee);
        }
        if (transferee !== undefined && transferee !== null) {
            queryParameters = queryParameters.set('transferee', <any>transferee);
        }
        if (transferMode !== undefined && transferMode !== null) {
            queryParameters = queryParameters.set('transferMode', <any>transferMode);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<TransferCallResponse>(`${this.basePath}/calls/transfer`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public transferCallWithDto1(organization?: string, login?: string, body?: TransferDto, observe?: 'body', reportProgress?: boolean): Observable<TransferCallResponse>;
    public transferCallWithDto1(organization?: string, login?: string, body?: TransferDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransferCallResponse>>;
    public transferCallWithDto1(organization?: string, login?: string, body?: TransferDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransferCallResponse>>;
    public transferCallWithDto1(organization?: string, login?: string, body?: TransferDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<TransferCallResponse>(`${this.basePath}/calls/transferWithDto`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
